// extracted by mini-css-extract-plugin
export default {"pulsatingDot":"jxhFLicMGlG1lmKMz_B9"};